import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { CardContent, Collapse } from "@mui/material";
import toast from "react-hot-toast";

import CustomButton from "../../../common/CustomButton";

import { getAge } from "../../../utils/date";
import { GetPrompt, SavePrompt, FilterEmailContent, } from "../../../redux/brg/actions";
import CustomDropDownToggle from "../../../common/CustomDropDownToggle";


function EmailContentFilterPrompt(props) {
    const [prompt, setPrompt] = useState('');
    const [isOpen, setIsOpen] = useState(true);
    const [temporaryPrompt, setTemporaryPrompt] = useState(null);

    useEffect(() => {
        // props.GetPrompt("email-filter-prompt");
    }, []);

    useEffect(() => {
        if (props.Brg.emailFilterPrompt?.id) {
            setPrompt(props.Brg.emailFilterPrompt?.text);
        }
    }, [props.Brg.emailFilterPrompt?.id])


    const arrange = (emailContent) => {
        const sp = emailContent?.["suggestions"] || emailContent?.["suggested_programs"];

        let content = "";
        content += `Email Subject: ${emailContent?.email_subject}\n\n`;
        content += `Email Preview Text: ${emailContent?.email_preview_text}\n\n`;
        content += `Headline 1: ${emailContent?.headline_1}\n\n`;
        content += `Subtext 1: ${emailContent?.subtext_1}\n\n`;
        content += `Headline 2: ${emailContent?.headline_2}\n\n`;
        content += `Subtext 2: ${emailContent?.subtext_2}\n\n`;
        content += `Headline 3: ${emailContent?.headline_3}\n\n`;
        content += `Suggested Programs: \n`;
        for (let i = 0; i < sp.length; i++) {
            content += `    ${sp[i]?.program_name}\n\n`;
            content += `    ${sp[i]?.program_description}\n\n`;
        }
        content += `\nSubtext 3: ${emailContent?.subtext_3}\n\n`;
        content += `Sign Off: ${emailContent?.sign_off}\n\n`;

        return content;
    }

    const processPrompt = (pPrompt) => {
        const arrangedEmail = arrange(JSON.parse(props?.email?.email_content));
        let processed = pPrompt;
        processed = processed.replace("{emailContent}", `"""\n${arrangedEmail}\n"""`);

        return processed;
    }


    const savePrompt = async (showPrompt = true) => {
        let tp = prompt;
        if (temporaryPrompt) {
            tp = temporaryPrompt;
            setPrompt(p => tp);
            setTemporaryPrompt(t => null);
        }

        const res = await props.SavePrompt(props.Brg.emailFilterPrompt, tp);

        if (res) {
            showPrompt && toast.success("Prompt updated!");
        } else {
            showPrompt && toast.error("Failed to update prompt!");
        }

        return tp;
    }

    const handleFilterEmail = async (pPrompt, toastID) => {
        const processedPrompt = await processPrompt(pPrompt);


        const res = await props.FilterEmailContent(processedPrompt, props?.patient?.id, props?.email);

        if (res.success) {
            toast.success('Email generated!', {
                id: toastID,
            });
        } else {
            toast.error('Failed to generate email!', {
                id: toastID,
            });
        }
    }

    return (
        <>
            <div className="brg-pp brg-pp-email-prompt">
                {/* <CustomDropDownToggle isOpen={isOpen} toggle={() => {
                    setIsOpen(!isOpen);
                }} /> */}

                <h5>
                    Filter Prompt
                </h5>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <div className="brg-pp-em-group">
                        <pre contentEditable={true} onInput={(e) => {
                            setTemporaryPrompt(e.target.outerText);
                        }}>
                            {`${prompt}`}
                        </pre>
                        <div >

                            <CustomButton size="small" isPrimary={false} onClick={() => {
                                savePrompt();
                            }}>
                                SAVE PROMPT
                            </CustomButton>
                        </div>
                    </div>
                </Collapse>
                {/* 
                <div id="generate-email-wrapper">

                    <CustomButton size="small" onClick={async () => {
                        const toastID = toast.loading("Generating filtered email...");
                        const tp = await savePrompt(false);
                        handleFilterEmail(tp, toastID);
                    }}>
                        FILTER EMAIL
                    </CustomButton>

                </div> */}
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    Brg: state.Brg
})

export default connect(mapStateToProps, {
    GetPrompt,
    SavePrompt,
    FilterEmailContent,
})(EmailContentFilterPrompt);
